import PropTypes from 'prop-types';

function between(min, max) {
  return (props, propName, componentName) => {
    const { propName: num } = props;
    if (typeof num !== 'number') {
      return new Error(
        `Invalid type of '${propName}' supplied to '${componentName}'. Validation failed.`,
      );
    }
    if (num < min || num > max) {
      return new Error(
        `Invalid prop '${propName}' supplied to '${componentName}'. Validation failed.`,
      );
    }
    return null;
  };
}

function noop() {}

function singleOrArray(propType) {
  return PropTypes.oneOfType([PropTypes.arrayOf(propType), propType]);
}

export { between, noop, singleOrArray };

export const childNodes = PropTypes.oneOfType([
  PropTypes.node,
  PropTypes.arrayOf(PropTypes.node),
]);

export const numberOrBlank = PropTypes.oneOfType([
  PropTypes.oneOf(['']),
  PropTypes.number,
]);

export const stringOrFunction = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.func,
]);

export const component = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.object,
]);
